import React, { useEffect, useRef, useState } from "react";
// import InputDropdown from "./InputDropdown";
import PropTypes from "prop-types";

const InputField = ({
  type = "text",
  name,
  placeholder,
  value,
  leadingIcon,
  label,
  hintText,
  helpIcon,
  destructive,
  disabled,
  onChange = null,
  className = "",
  autoComplete = "off",
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <div
      className={`inputFieldContainer${
        destructive ? " destructive" : ""
      } ${className}`}
    >
      {label && (
        <label className="inputFieldLabel" htmlFor="input-field">
          {label}
        </label>
      )}
      <div
        className={`inputWrapper${focused && !disabled ? " focused" : ""}${
          disabled ? " disabled" : ""
        }`}
      >
        <div className="inputLeftWrapper">
          {leadingIcon && leadingIcon}
          {/* {type === "leadingDropdown"&& <div><InputDropdown type="sm" /></div>} */}
          <input
            ref={ref}
            className="inputField"
            name={name}
            placeholder={placeholder}
            value={value}
            onWheel={(e) => {
              if (type === "number") {
                e.target.blur();
                setFocused(false);
              }
            }}
            onFocus={() => setFocused(true)}
            disabled={disabled}
            onChange={onChange}
            type={type}
            autoComplete={autoComplete}
            {...props}
          />
        </div>
        {/* {type === "trailingDropdown"&& <div><InputDropdown type="sm" /></div>} */}
      </div>
      {(hintText || props.maxLength) && (
        <div
          className={["inputFieldFooter", props.maxLength && "withMaxLength"]
            .filter(Boolean)
            .join(" ")}
        >
          {hintText && <p className="inputFieldHintText">{hintText}</p>}

          {props.maxLength && (
            <p className="inputFieldCharCount">
              {value?.length || 0}/{props.maxLength}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default InputField;

InputField.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  leadingIcon: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  hintText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  helpIcon: PropTypes.element,
  destructive: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.any,
};

InputField.defaultProps = {
  value: "",
  name: "",
  type: "default",
  leadingIcon: null,
  placeholder: "Enter the name",
  destructive: false,
  disabled: false,
  helpIcon: null,
};
